/**
 * Drawer = right-side Sheet for V1. The revision drawer (DES-15) uses this.
 *
 * We re-export Sheet primitives under Drawer names so consumers can switch to
 * a different drawer primitive in Phase 2 without per-call refactors.
 */
import * as React from 'react';
import {
  Sheet,
  SheetTrigger,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';

const Drawer = Sheet;
const DrawerTrigger = SheetTrigger;
const DrawerClose = SheetClose;

const DrawerContent: React.FC<React.ComponentProps<typeof SheetContent>> = ({
  side = 'right',
  ...props
}) => <SheetContent side={side} {...props} />;

const DrawerHeader = SheetHeader;
const DrawerTitle = SheetTitle;
const DrawerDescription = SheetDescription;

export {
  Drawer,
  DrawerTrigger,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
};
